document.addEventListener('on:facet-filters:updated', e => {
  window.dispatchEvent(new Event("scroll"))
});

document.addEventListener("BSS:openQuickBuy", e => {
  setTimeout(() => {
    updateVariant();
    const variantId = +document.querySelector(`quick-add-drawer [action="/cart/add"] [name="id"]`)?.value;
    if(variantId) return;
          variant = BSS_B2B.storage.variantStorage.get(variantId);
      if (variant?.appliedCP){
              const cpPrices = {
                  price: variant.bssB2BPriceAfterCP,
                  comparePrice: variant.compare_at_price ?? variant.price,
                  originalPrice: variant.price,
              };
          const priceElements = document.querySelectorAll("quick-add-drawer .product-info__price>span")
              priceElements.forEach((priceElement) => {
                  BSS_B2B.cp?.utils?.product?.showPriceBase(priceElement, cpPrices);
              });
      }
    changeVariantQV();
  }, 1000)
});

function changeVariantQV(){
  document.querySelector("variant-picker").addEventListener("on:variant:change", e => {
      updateVariant();
      let { variant } = e.detail;
      variant = BSS_B2B.storage.variantStorage.get(variant.id);
      if (variant?.appliedCP){
              const cpPrices = {
                  price: variant.bssB2BPriceAfterCP,
                  comparePrice: variant.compare_at_price ?? variant.price,
                  originalPrice: variant.price,
              };
          const priceElements = document.querySelectorAll("quick-add-drawer .product-info__price>span")
              priceElements.forEach((priceElement) => {
                  BSS_B2B.cp?.utils?.product?.showPriceBase(priceElement, cpPrices);
              });
      }
  })
}
  function updateVariant(){
      const CP_KEY = 'cp';
    for (const [a,product] of BSS_B2B.storage.productStorage.store) {
      product.variants.forEach((variant, ind) => {
          const appliedRule = BSS_B2B.cp.utils.common.getCustomerAppliedRules().find(rule => BSS_B2B.cp.utils.common.checkProduct(rule, { ...product, currentVariant: variant }))
          if (appliedRule) {
              product.variants[ind].appliedCP = appliedRule;
              const { discount_type, discount_value } = appliedRule;
              const modifiedPrice = BSS_B2B.cp.utils.common.calculateDiscount(variant.price, discount_type, Number(discount_value));
              if (modifiedPrice !== variant.price) {
                  product.variants[ind].bssB2BPriceAfterCP = modifiedPrice;
                  product.variants[ind].bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(variant.bssB2bShowPriceKey, CP_KEY);
                  product.bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(product.bssB2bShowPriceKey, CP_KEY);
              } else {
                  delete variant.appliedCP;
                  delete variant.bssB2BPriceAfterCP;
                  if (variant.bssB2bShowPriceKey === CP_KEY) {
                      delete variant.bssB2bShowPriceKey;
                  }
                  if (product.bssB2bShowPriceKey === CP_KEY) {
                      delete product.bssB2bShowPriceKey;
                  }
              }
              BSS_B2B.storage.variantStorage.set(variant.id, variant);
              BSS_B2B.storage.productStorage.set(product.id, product);
          }
      })
  }
}
// HC CUSTOM: Stop BSS B2B treating Route's cloned checkout button as a second
// checkout button.
//
// Route's "preferred checkout" clones our checkout button -- keeping
// name="checkout" -- and hides the original. BSS's getCheckoutElements() then
// matches BOTH, binds its click interceptor to both, and builds a
// loading-spinner clone of each (setCheckoutBtnLoading inserts a visible copy
// and hides the source). That is what produced the duplicated buttons on the
// cart page: measured 4 checkout elements in #cart-summary, up to 3 visible at
// once, immediately before navigating to checkout.
//
// BSS filters its own element lookup, so narrow it to the single real theme
// button -- the shallowest match in the DOM, since both apps insert clones into
// wrappers they create. Route still re-clicks that button, so BSS's custom
// pricing draft order (the "guide price" at checkout) is unaffected; verified
// by observing BSS's handler still run and checkout still complete.
//
// Note: this halves the clones but does not fully remove the flash, because
// BSS's checkout handler fires twice per checkout click. The real fix is for
// Route to drop `name` from its clone (their removeCheckoutButtonAttributes
// list already includes it) -- raised with Route.
(function () {
  var FILTER = 'custom:cart/checkout_ele';

  /**
   * Depth of an element from the document root.
   * @param {Element} el - Element to measure.
   * @returns {number} Number of ancestors.
   */
  function domDepth(el) {
    var depth = 0;
    while (el.parentElement) {
      el = el.parentElement;
      depth += 1;
    }
    return depth;
  }

  /**
   * Narrows BSS's checkout-element list to the real theme button.
   * @param {NodeList} nodes - Elements BSS matched.
   * @returns {Array} Array (BSS calls both for..of and .forEach on this).
   */
  function pickRealCheckoutButton(nodes) {
    var all = Array.prototype.slice.call(nodes || []);
    if (all.length < 2) return all;

    // Ignore BSS's own spinner clones when choosing.
    var candidates = all.filter(function (el) {
      return !el.hasAttribute('bss-b2b-checkout-loader');
    });
    if (!candidates.length) return all;

    var best = candidates[0];
    var bestDepth = domDepth(best);
    for (var i = 1; i < candidates.length; i += 1) {
      var depth = domDepth(candidates[i]);
      if (depth < bestDepth) {
        best = candidates[i];
        bestDepth = depth;
      }
    }
    return [best];
  }

  // Register directly on the hooks object rather than via
  // BSS_B2B.custom.addFilter, so load order does not matter (this file is
  // deferred and the app bundle may not have run yet). Re-asserted on the usual
  // lifecycle events in case the bundle initialises the object after us.
  function register() {
    window.bssB2BHooks = window.bssB2BHooks || { actions: {}, filters: {} };
    window.bssB2BHooks.filters = window.bssB2BHooks.filters || {};
    window.bssB2BHooks.filters[FILTER] = pickRealCheckoutButton;
  }

  register();
  document.addEventListener('DOMContentLoaded', register);
  window.addEventListener('load', register);
})();
